import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LogNewInvitationListEntry, LogNewSubmissionListEntry, LogStepEntry } from 'interfaces/log-step.interface';

@Component({
  selector: 'cm-log-entries',
  templateUrl: './log-entries.component.html',
  styleUrls: ['./log-entries.component.scss'],
})
export class LogEntriesComponent {
  @Input() selectedEntryIndex: number;

  @Input() entries: LogStepEntry[] | LogNewSubmissionListEntry[] | LogNewInvitationListEntry[] = [];
  @Output() clickEntry: EventEmitter<any> = new EventEmitter();

  @Input() allowMultipleEntries = false;

  onClick(index, entry) {
    this.selectedEntryIndex = index;
    this.clickEntry.emit({ entry, index });
  }
}
